<template>
  <div class="cities font-grotesque">
    <div v-if="((!dark && !city.$dark) || (dark && city.$dark)) && city.$coordX && city.$coordY" :style="`top: ${city.$coordY}%; left: ${city.$coordX}%`" :class="`cities-city cities-city-${active[key] ? 'active' : ''} cities-city-${isStroked(city, 80) ? 'right' : ''}`" v-for="city, key in cities">
      <div class="cities-city--info">
        <svg class="cities-pin" width="14" height="39" viewBox="0 0 14 39">
            <defs>
              <linearGradient id="pin-a" x1="70.669%" x2="35.079%" y1="26.711%" y2="6.078%">
                <stop stop-color="#FF8686" offset="0%"/>
                <stop stop-color="#FFB468" offset="100%"/>
              </linearGradient>
            </defs>
            <path fill="url(#pin-a)" fill-rule="evenodd" d="M7.7,14.1554093 C11.2373259,13.8042022 14,10.8197157 14,7.189972 C14,3.32397876 10.8659932,0.189972004 7,0.189972004 C3.13400675,0.189972004 0,3.32397876 0,7.189972 C0,10.8197157 2.76267411,13.8042022 6.3,14.1554093 L6.3,38.5427772 L7.7,38.5427772 L7.7,14.1554093 Z"/>
        </svg>
      </div>

      <div class="cities-city--hover" @mouseenter="switchPopup(key, true)" @mouseleave="switchPopup(key, false)"/>
      <div v-if="isStroked(city, 90)" class="cities-city--popup cities-city--popup-mask">
         <p class="cities-city--name" v-html="city.text.item[lang].title"/>
        <div class="small" v-html="city.text.item[lang].main_content_short"/>
      </div>
      <div class="cities-city--popup">
         <p class="cities-city--name" v-html="city.text.item[lang].title"/>
        <div class="small" v-html="city.text.item[lang].main_content_short"/>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';

export default {
  name: 'cities',
  props: ['dark'],
  computed: mapGetters({
    cities: 'cities',
    lang: 'lang',
  }),
  data() {
    return {
      active: [],
    };
  },

  methods: {
    isStroked(city, limit) {
      return Number(city.$coordX) > limit;
    },

    switchPopup(key, state) {
      Vue.set(this.active, key, state);
    },
  },
};
</script>

<style>
.page-about.page-white{
  .cities-city--popup,
  .cities-city--info{
    color: black;
  }

  .cities-city-right{
    .cities-city--popup{
      position: absolute;
      border-radius: 3px;
      padding: 8px 10px 0;
      text-align: right;
      width: 160px;
      left: -180px;
    }
  }
}

.cities{
  font-size: 70%;
  height: 100%;
  width: 110%;
  margin: 0;

  &,
  &-city{
    position: absolute;
    top: 3.5%;
    left: 0;
  }
  &-city{
    transform: translate3d(0,-50%,0);
    overflow: hidden;
    padding: 2px;
    color: white;
    height: 43px;
    width: 16px;

/*    @media (max-width: $mediaMob) {
      margin-top: 2%;
    }

    @media (max-width: $mediaMini) {
      margin-top: 1%;
    }*/
    &--hover{
      position: absolute;
      z-index: 999;
      height: 12px;
      width: 12px;
      left: 2px;
      top: 4px;
    }

    &-active{
      overflow: visible;
      z-index: 999;
      width: 250px;
    }

    &--name{
      line-height: 1.3;
      margin: 2px 0 8px;
    }
    &--info{
      max-width: 14px;
    }
    &--info,
    &--popup{
      display: inline-block;
      vertical-align: top;
    }

    &--popup,
    &--name{
      opacity: 0;
    }

    &--popup{
      margin-left: 10px;
      text-align: left;
      max-width: 200px;
      p{
        max-width: 180px;
        margin-top: 0;
      }

      &-mask{
        -webkit-text-stroke: 0.3em white;
        color: white;

        .app-ie-10,
        .app-ie-11,
        .app-ie &{
          background: rgba(255,255,255,.7);
          -webkit-text-stroke: 0;
          color: black;
        }
      }
    }
  }

  &-pin{
    transition: transform .2s cubic-bezier(0.580, -0.330, 0.170, 1.325);
    transform-origin: 25% center;
    transform: scale(1);
    margin: 0;
    /*cursor: pointer;*/
    max-width: 35px;
    z-index: 99;
    width: 100%;

    &-active{
      transform: scale(1.2);
      cursor: auto;
      opacity: 1;
    }
  }
  &-city{
    transform-origin: center center;
    &-active{
      .cities-pin{
        transform: scale(1.3) translate3d(-8%,0,0);
      }
      .cities-city--popup,
      .cities-city--name{
        transition: all .3s ease-in-out;
        transform: translate3d(0,0,0);
        opacity: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Cities.vue